<template>
    <v-container fluid style="height: auto">
            <v-row v-for="(item, indexAlbum) in modelItems"
                   :key="indexAlbum"
            >
                <v-row v-for="(item, indexItem) in modelItems[indexAlbum]['conditions']"
                       :key="indexItem">
                <v-col cols="1" class="pa-0 mx-1">
                    <v-select
                            v-model="modelItems[indexAlbum]['conditions'][indexItem][0]"
                            :items="[{value: 1, text: 'И'}, {value: 2, text: 'ИЛИ'}]"
                            hide-details
                            @change="changeItems"
                            v-if="indexItem > 0"
                    ></v-select>
                    <v-text-field value="Если" disabled hide-details v-else></v-text-field>
                </v-col>
                <v-col cols="3" class="pa-0 mx-1">
                    <v-select
                            v-model="modelItems[indexAlbum]['conditions'][indexItem][1]"
                            :items="variablesToConditions"
                            hide-details
                            @change="changeVariableToCondition(indexAlbum)"
                    ></v-select>
                </v-col>
                <v-col cols="3" class="pa-0 mx-1" v-show="modelItems[indexAlbum]['conditions'][indexItem][1] === 1">
                    <v-select
                            v-model="modelItems[indexAlbum]['conditions'][indexItem][2]"
                            :items="scenarios.variables"
                            item-text="title"
                            item-value="id"
                            hide-details
                            @change="changeItems"
                    ></v-select>
                </v-col>
                <v-col cols="1" class="pa-0 mx-0">
                    <v-select
                            v-model="modelItems[indexAlbum]['conditions'][indexItem][3]"
                            :items="getConditionType(modelItems[indexAlbum]['conditions'][indexItem][1])"
                            hide-details
                            @change="changeItems"
                    ></v-select>
                </v-col>
                <v-col cols="2" class="pa-0 mx-1" v-show="modelItems[indexAlbum]['conditions'][indexItem][1] !== 4 && modelItems[indexAlbum]['conditions'][indexItem][1] !== 5">
                    <v-text-field
                            v-model="modelItems[indexAlbum]['conditions'][indexItem][4]"
                            hide-details
                            @input="changeItems"
                    ></v-text-field>
                </v-col>
                    <v-col cols="1">
                        <v-btn icon @click="deleteCondition(indexAlbum, indexItem)" small v-show="indexItem > 0"><v-icon small>delete</v-icon></v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4">
                        <v-btn @click="addCondition(indexAlbum)" class="py-1 my-2" small><span class="caption">Добавить условие</span></v-btn>
                    </v-col>
                </v-row>
                <v-row>
                <v-col cols="4" class="py-0 mx-1">
                    <v-text-field
                            label="Напишите id альбома, или напищите 0 если нужно искать во всех альбомах"
                            v-model="modelItems[indexAlbum]['album_id']"
                            :rules="[rules.positive]"
                            type="number"
                            value="0"
                            @input="changeItems"
                    ></v-text-field>
                </v-col>
                <v-col cols="4" class="py-0 mx-1">
                    <v-text-field
                            label="Максимальное количество товаров которые нужно прикрепить к сообщению"
                            v-model="modelItems[indexAlbum]['count_product']"
                            :rules="[rules.min, rules.max]"
                            type="number"
                            value="1"
                            @input="changeItems"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0 mx-1">
                    <v-text-field
                            label="Текст для поиска с использованием переменных без мат. вычислений"
                            v-model="modelItems[indexAlbum]['text_to_find']"
                            @input="changeItems"
                    ></v-text-field>
                </v-col>
                </v-row>
            </v-row>
        <v-row>
            <v-col cols="4">
                <v-btn @click="addAlbum" class="py-1 my-2" small><span class="caption">Добавить Альбом</span></v-btn>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: 'ModuleMarketConditions',
    data() {
        return {
            selectedItems: [],
            rules: {
                positive: value => value >= 0 || 'Число должно быть положительным',
                min: value => value >= 1 || 'Число должно быть больше 0',
                max: value => value <= 10 || 'Число должно быть меньше 11'
            },
            variablesToConditions: [
                { text: 'Переменная', value: 1 }
            ],
            conditionTypes: [
                { text: '=', value: 1 },
                { text: '≠', value: 2 },
                { text: '<', value: 3 },
                { text: '⩽', value: 4 },
                { text: '>', value: 5 },
                { text: '⩾', value: 6 },
                { text: 'Есть', value: 7 },
                { text: 'Нет', value: 8 },
                { text: 'Да', value: 9 },
                { text: 'Мужской', value: 10 },
                { text: 'Женский', value: 11 },
                { text: 'Не указан', value: 12 }
            ],
            mainString: [0, 1, 0, 0, '']
        }
    },
    props: ['label', 'itemsInModule', 'params', 'load', 'modelItems', 'methodId', 'index', 'indexCell'],
    computed: {
        ...mapState(['scenarios'])
    },
    methods: {
        getConditionType(variableToConditionId) {
            switch (variableToConditionId) {
            case 1:
                return this.getConditionTypesByIndexes([0, 1, 2, 3, 4, 5])
            case 2:
                return this.getConditionTypesByIndexes([6, 7])
            case 3:
                return this.getConditionTypesByIndexes([6, 7])
            case 4:
                return this.getConditionTypesByIndexes([7, 8])
            case 5:
                return this.getConditionTypesByIndexes([9, 10, 11])
            default:
                return this.getConditionTypesByIndexes([0, 1, 2, 3, 4, 5])
            }
        },
        getConditionTypesByIndexes(indexes) {
            let conditionTypes = []
            indexes.forEach((index) => {
                conditionTypes.push(this.conditionTypes[index])
            })
            return conditionTypes
        },
        changeItems() {
            this.$emit('updateItems', { items: this.modelItems, methodId: this.methodId, index: this.index, indexCell: this.indexCell })
        },
        addCondition(indexAlbum) {
            this.modelItems[indexAlbum]['conditions'].push([1, 1, 0, 1, ''])
            this.changeItems()
        },
        deleteCondition(indexAlbum, indexItem) {
            this.modelItems[indexAlbum]['conditions'].splice(indexItem, 1)
            this.changeItems()
        },
        changeVariableToCondition(indexItem) {
            this.modelItems[indexItem][3] = this.getConditionType(this.modelItems[indexItem][1])[0].value
            this.changeItems()
        },
        addAlbum() {
            this.modelItems.push({ 'conditions': [[1, 1, 0, 1, '']], 'album_id': 0, 'count_product': 3 })
        }
    },
    created() {
        this.$store.dispatch('scenarios/variablesAll', this.$route.params['pathMatch'])
    }

}
</script>

<style scoped>
    .container {
        height: auto;
    }
</style>
